import type { InputHTMLAttributes, ReactNode } from "react";

type MarketInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> & {
  label: string;
  value: string | number | undefined;
  onChange: (value: string) => void;
  suffix?: string;
};

export function MarketInput({ label, value, onChange, suffix, ...props }: MarketInputProps) {
  return (
    <label className="market-field">
      <span>{label}</span>
      <div className="market-input-wrap">
        <input {...props} value={value ?? ""} onChange={(event) => onChange(event.target.value)} />
        {suffix ? <small>{suffix}</small> : null}
      </div>
    </label>
  );
}

type MarketSelectProps = {
  label: string;
  value: string;
  options: readonly string[];
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
};

export function MarketSelect({ label, value, options, onChange, placeholder = "Vyberte", disabled }: MarketSelectProps) {
  return (
    <label className="market-field">
      <span>{label}</span>
      <div className="market-select-wrap">
        <select value={value} onChange={(event) => onChange(event.target.value)} disabled={disabled}>
          <option value="">{placeholder}</option>
          {options.map((option) => <option key={option} value={option}>{option}</option>)}
        </select>
      </div>
    </label>
  );
}

export function MarketFieldSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <fieldset className="market-field-section">
      <legend>{title}</legend>
      <div className="market-form-grid">{children}</div>
    </fieldset>
  );
}
